<template>
  <footer class="custom-footer pt-5 pb-3 mt-5 border-top">
    <b-container>
      <b-row class="text-start d-flex flex-nowrap justify-content-between align-items-start desktop-row">
        
        <!-- Brand Section -->
        <b-col class="flex-grow-0 mb-4 me-3">
          <h5 class="fw-bold text-dark-blue text-left">CraftMyStories</h5>
          <p class="small text-muted mb-0 text-justify">Personalized stories and treasured keepsakes.</p>
          <p class="small text-muted mb-0 text-justify">Copyright &copy; 2025 Craftwise. All rights reserved.</p>
           <p class="small text-muted mb-0 text-justify">CraftMyStories.com is owned and operated by Craftwise.</p>
        </b-col>

        <!-- Mission Section -->
        <b-col class="flex-grow-0 mb-4 me-3" style="max-width: 300px;">
          <h5 class="fw-bold text-dark-blue text-left">Our Mission</h5>
          <p class="small text-muted mb-0 mission-text text-justify">
            Our mission is to make reading irresistible and to spark a lifelong love for books. Through personalized & engaging stories, we aim to ignite imagination, build confidence and nurture creativity, curiosity and self-belief. With one story at a time, we hope to inspire our readers to become the best storytellers of their own lives- a Human Superpower!
          </p>
        </b-col>

        <!-- Quick Links Section -->
        <b-col class="flex-grow-0 mb-4 me-3">
          <h5 class="fw-bold text-dark-blue text-left">Quick Links</h5>
          <ul class="list-unstyled small text-left">
            <li class="mb-1">
<router-link to="/about" class="text-muted text-decoration-none text-justify">About Us</router-link>            </li>
            <li class="mb-1">
 <router-link to="/contact" class="text-muted text-decoration-none text-justify">Info & Contact Us</router-link>            </li>
            <li class="mb-1">
 <router-link to="/privacy" class="text-muted text-decoration-none text-justify">Privacy Policy</router-link>            </li>
            <li class="mb-1">
 <router-link to="/terms&service" class="text-muted text-decoration-none text-justify">Terms Of Service</router-link>            </li>
          </ul>
        </b-col>

        <!-- Connect Section -->
        <b-col class="flex-grow-0 mb-4">
          <h5 class="fw-bold text-dark-blue text-left">Connect</h5>
          <div class="social-icons text-left">
          <a href="https://www.facebook.com/profile.php?id=61584701434925&sk=grid" target="_blank" class="social-icon me-3 text-decoration-none">
<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" viewBox="0 0 16 16">
        <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951"/>
      </svg>          </a>
            <a href="https://www.instagram.com/craft_my_stories/" target="_blank" class="social-icon text-decoration-none">
<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" viewBox="0 0 16 16">
        <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.003 1.444c2.136 0 2.389.008 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.282.11-.705.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334"/>
      </svg>            </a>
            <!-- <b-link href="#" class="social-icon me-3"><i class="bi bi-twitter"></i></b-link> -->
            <!-- <b-link href="#" class="social-icon me-3"><i class="bi bi-pinterest"></i></b-link> -->
          </div>
        </b-col>

      </b-row>
    </b-container>
  </footer>
</template>

<style scoped>
.custom-footer {
  background-color: #dce9f7ff;
  
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  width: 100vw;
  box-sizing: border-box;
}

.custom-footer .text-muted {
  color: #6c757d !important;
  text-decoration: none;
  transition: color 0.2s ease;
}

.custom-footer a.text-muted:hover {
  color: #ff7a00 !important;
}

.custom-footer .social-icon {
  color: #0c0a0aff;
  font-size: 1.8rem;
  text-decoration: none;
}

.custom-footer .social-icon:hover {
  color: #ff7a00 !important;
}

.mission-text {
  text-align: justify;
  text-justify: inter-word;
}

/* Text alignment utilities */
.text-left {
  text-align: left !important;
}

.text-justify {
  text-align: justify !important;
  text-justify: inter-word !important;
}
.router-link-active {
  color: #ff7a00 !important;
  font-weight: 500;
}


.social-icon i {
  display: inline-flex !important; 
  align-items: center;
  justify-content: center;
  min-width: 1.8rem;
  min-height: 1.8rem;
  font-style: normal !important;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.bi {
  font-family: "bootstrap-icons" !important;
}
/* Desktop view - unchanged horizontal layout */
.desktop-row {
  flex-wrap: nowrap !important;
  gap: 1rem;
  margin-left: 30px;
}

b-col {
  flex-shrink: 0;
}

/* ========== SPECIFIC DEVICE BREAKPOINTS ONLY ========== */

/* iPad Mini (768px) - VERTICAL LAYOUT */
@media (max-width: 820px) and (min-width: 768px) {
  .desktop-row {
    flex-wrap: wrap !important;
    gap: 2rem !important;
    margin-left: 20px !important;
    margin-right: 20px !important;
  }
  
  b-col {
    min-width: 100% !important;
    max-width: 100% !important;
    flex: 0 0 100% !important;
    text-align: left !important;
    margin-bottom: 1.5rem !important;
  }
  
  .mission-text {
    text-align: justify !important;
    max-width: 100% !important;
  }
}

/* iPad Air (834px) - VERTICAL LAYOUT */
@media (max-width: 852px) and (min-width: 821px) {
  .desktop-row {
    flex-wrap: wrap !important;
    gap: 2rem !important;
    margin-left: 25px !important;
    margin-right: 25px !important;
  }
  
  b-col {
    min-width: 100% !important;
    max-width: 100% !important;
    flex: 0 0 100% !important;
    text-align: left !important;
    margin-bottom: 1.5rem !important;
  }
  
  .mission-text {
    text-align: justify !important;
    max-width: 100% !important;
  }
}

/* Asus Zenbook Fold (853×1280) - VERTICAL LAYOUT */
@media (max-width: 900px) and (min-width: 853px) {
  .desktop-row {
    flex-wrap: wrap !important;
    gap: 2rem !important;
    margin-left: 30px !important;
    margin-right: 30px !important;
  }
  
  b-col {
    min-width: 100% !important;
    max-width: 100% !important;
    flex: 0 0 100% !important;
    text-align: left !important;
    margin-bottom: 1.5rem !important;
  }
  
  .mission-text {
    text-align: justify !important;
    max-width: 100% !important;
  }
}

@media (width: 912px) and (height: 1368px) {
  .desktop-row {
    display: flex !important;
    flex-direction: column !important;
    flex-wrap: nowrap !important;
    gap: 2rem !important;
    margin-left: 30px !important;
    margin-right: 30px !important;
  }
  
  .desktop-row b-col {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    flex: 0 0 auto !important;
    margin-bottom: 0 !important;
    margin-right: 0 !important;
  }
  
  .mission-text {
    max-width: 100% !important;
  }
  
  /* Remove any horizontal spacing */
  .me-3 {
    margin-right: 0 !important;
  }
  
  .flex-grow-0 {
    flex-grow: 1 !important;
  }
  
  .flex-nowrap {
    flex-wrap: wrap !important;
  }
  
  .justify-content-between {
    justify-content: flex-start !important;
  }
  
  .align-items-start {
    align-items: flex-start !important;
  }
}

/* Mobile adjustments ONLY - for screens up to 767px */
@media (max-width: 767.98px) {
  .desktop-row {
    flex-wrap: wrap !important;
    overflow-x: visible !important;
    padding-bottom: 0;
    gap: 2rem;
    margin-left: 15px !important;
    margin-right: 15px !important;
  }
  
  b-col {
    min-width: 100% !important;
    max-width: 100% !important;
    flex: 0 0 100% !important;
    text-align: left !important;
    margin-bottom: 1.5rem !important;
  }
  
  .mission-text {
    text-align: justify !important;
    max-width: 100% !important;
  }
  
  .social-icons {
    justify-content: flex-start !important;
  }
}

/* Large monitor adjustments - for screens 1200px and above */
@media (min-width: 1200px) {
  .desktop-row {
    justify-content: space-around !important;
    margin-left: 50px !important;
  }
  
  .mission-text {
    max-width: 350px !important;
  }
}

/* For list items to maintain proper spacing */
.list-unstyled li {
  margin-bottom: 0.25rem;
}

.social-icons {
  display: flex;
  flex-wrap: wrap;
}
</style>